import { Component, OnInit, OnDestroy } from '@angular/core';
import { BankAcc } from '../../../../models/BankAcc';
import { AdminService } from '../../../../services/Admin.service';
import { Router } from '@angular/router';
import { ConfirmationPageSuccessComponent } from '../../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { ConfirmationPageFailComponent } from '../../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { BusyIndicatorComponent } from '../../../../shared-components/busy-indicator/busy-indicator.component';


@Component({
  selector: 'app-bank-accounts',
  templateUrl: './bank-accounts.component.html',
  styleUrls: ['./bank-accounts.component.scss']
})
export class BankAccountsComponent implements OnInit, OnDestroy {
  public bankAccountList: BankAcc[];
  public rowsOnPage = 5;
  public ccPage = 1;
  public sortBy = '';
  public sortOrder = 'asc';
  public errorMsg: string;
  public successMsg: string;
  public showSuccessConfirmation = false;
  public showFailConfirmation = false;

  private alive = true;

  constructor(private adminSvc: AdminService, private router: Router,  private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.getBankAccounts();
  }

  getBankAccounts() {
      this.adminSvc.getBankAccounts()
      .takeWhile(() => this.alive)
      .subscribe(data => {
        this.bankAccountList = data;
      }
    );
  }
  onBankAccDelete(baccount: BankAcc)  {
    if (confirm('Do you want to delete Bank Account ' + baccount.AccountNickname + '?') === true) {
      // call to delete
      console.log('inside on delete');
      this.spinner.show();
      console.log('after spinner  show');
      this.adminSvc.deleteBankAccount(baccount.BAID)
      .takeWhile(() => this.alive)
      .subscribe(data => {
        this.showFailConfirmation = false;
        this.showSuccessConfirmation = true;
        this.errorMsg = null;
        this.successMsg = 'Your bank account ' + baccount.AccountNickname + ' has been deleted successfully';
      },
      error => {
        this.showFailConfirmation = true;
        this.showSuccessConfirmation = false;
        this.errorMsg = 'Your bank account ' + baccount.AccountNickname + ' has been deleted successfully';
        this.successMsg = null;
      });
    }
    this.spinner.hide();
  }
  redirectTo(event) {
    this.getBankAccounts();
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  close() {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
    this.getBankAccounts();
  }
  public ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/client/my-settings/bank-accounts/bank-accounts.component.ts